import * as React from 'react';
import Map, {Source, Layer} from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import {CircularProgress} from "@mui/material";

export const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export const delay = ms => new Promise(res => setTimeout(res, ms));
export default function MapBlaster({tile}) {

    const [bbox, setBBbox] = React.useState(null);

    const [rect, setRect] = React.useState(null);

    React.useEffect(() => {
        setBBbox(null);
        setRect(null)
        delay(100).then(() => {
            if (tile) {
                let coord = JSON.parse(tile.location)

                setBBbox(coord);
                let rect = {
                    "type": "FeatureCollection",
                    "features": [
                        {
                            "type": "Feature",
                            "geometry": {
                                "type": "Polygon",
                                "coordinates": [
                                    [
                                        [coord[0][0], coord[0][1]],
                                        [coord[1][0], coord[0][1]],
                                        [coord[1][0], coord[1][1]],
                                        [coord[0][0], coord[1][1]],
                                        [coord[0][0], coord[0][1]],

                                    ]
                                ]
                            },
                            "properties": {"name": "area1"}
                        }
                    ]
                }

                setRect(rect)
            }
        })
    }, [tile]);

    if (bbox && rect) {
        return (
            <Map
                initialViewState={{
                    bounds: bbox

                }}
                mapStyle="mapbox://styles/mapbox/streets-v9"

                dragPan={true}
                mapboxAccessToken={MAPBOX_TOKEN}
            >
                <Source
                    type="geojson"
                    data={rect}>
                    <Layer
                        type={'fill'}
                        paint={{
                            'fill-color': "#dd110e",
                            'fill-opacity': 0.2,
                        }}
                    />
                </Source>
            </Map>)
    } else {
        return (
            <CircularProgress/>)
    }

}
